export default __webpack_public_path__ + "static/media/maintainButton.be1a9ff5.png";